const meta = {
  otel: 'OpenTelemetry Collector',
  collector: 'Chronosphere Collector',
  'prometheus-remote-write': {
    display: 'hidden',
  },
  gcp: 'Google Cloud',
  'aws-cloudwatch-metric-stream': 'Amazon Web Services (AWS)',
  troubleshooting: 'Troubleshooting',
};

export default meta;
